import { object, string, InferType } from 'yup';
import { IamCancerSchema } from '../../../IamCancerSchema';
import { PcpPatientServiceListSchema } from '../pcp';
import { baseAiGeneratedResponseSchema } from './baseAiGeneratedResponseSchema';
import { AiDateSchema } from './AiDateSchema';

export const PcpAiGeneratedSchema = object().shape({
  patient: object()
    .shape({
      iam: IamCancerSchema.nullable().notRequired(),
    })
    .nullable()
    .notRequired(),
  dateOfConsultation: AiDateSchema,
  notes: string().nullable().notRequired(),
  patientServices: PcpPatientServiceListSchema,
});

export type PcpAiGenerated = InferType<typeof PcpAiGeneratedSchema>;

export const PcpAiGeneratedResponseSchema =
  baseAiGeneratedResponseSchema(PcpAiGeneratedSchema);

export type PcpAiGeneratedResponse = InferType<
  typeof PcpAiGeneratedResponseSchema
>;
